"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../../components/index");
const react_final_form_1 = require("react-final-form");
const react_1 = __importDefault(require("react"));
function MultiSelectField({ name, label, validate, options, renderValue, selectAll, limitTags, readOnly, onChange, disabled, parse, format, }) {
    return (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate, parse: parse, format: format }, ({ input, meta }) => {
        const inputValues = Array.isArray(input.value) ? input.value : [];
        const values = options.filter((option) => {
            return inputValues.find((inputValue) => option.value === inputValue.value);
        });
        return (
        // @ts-ignore
        react_1.default.createElement(index_1.Select, { multiple: true, selectAll: selectAll, textFieldProps: {
                label: label,
                error: meta.touched && meta.invalid,
                helperText: meta.touched && meta.error,
            }, options: options, value: values, onChange: (newOptions) => {
                if (!newOptions) {
                    input.onChange(null);
                    onChange?.([]);
                }
                else {
                    input.onChange(newOptions);
                    onChange?.(newOptions);
                }
            }, renderValue: renderValue, limitTags: limitTags, readOnly: readOnly, disabled: disabled }));
    }));
}
exports.default = MultiSelectField;
